export default __webpack_public_path__ + "splash-05.87074.svg";